import { Link } from 'react-router-dom';
import { LINKEDIN_PAGE_URL, trackFollowClick } from '../utils/analytics';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <span className="site-footer__logo">FS</span>
          <div>
            <span className="site-footer__tagline">Food Safety Digest</span>
            <span className="site-footer__desc">EU food safety intelligence &amp; regulatory monitoring</span>
          </div>
        </div>
        <div className="site-footer__links">
          <Link to="/subscribe">Subscribe</Link>
          <span className="site-footer__sep">&middot;</span>
          <Link to="/feedback">Give feedback</Link>
          <span className="site-footer__sep">&middot;</span>
          <Link to="/privacy">Privacy</Link>
          <span className="site-footer__sep">&middot;</span>
          <a href="https://webgate.ec.europa.eu/rasff-window/screen/list" target="_blank" rel="noopener noreferrer">RASFF Portal</a>
          <span className="site-footer__sep">&middot;</span>
          <a href="https://www.efsa.europa.eu/" target="_blank" rel="noopener noreferrer">EFSA</a>
          <span className="site-footer__sep">&middot;</span>
          <a
            href={LINKEDIN_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackFollowClick('footer')}
          >
            Follow on LinkedIn
          </a>
        </div>
        <div className="site-footer__copy">
          &copy; {new Date().getFullYear()} Food Safety Digest &mdash; Data sourced from public sources
        </div>
      </div>
    </footer>
  );
}
